import { render, staticRenderFns } from "./AframeLoader.vue?vue&type=template&id=31389f7c&scoped=true&lang=pug&"
import script from "./AframeLoader.vue?vue&type=script&lang=js&"
export * from "./AframeLoader.vue?vue&type=script&lang=js&"
import style0 from "./AframeLoader.vue?vue&type=style&index=0&id=31389f7c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31389f7c",
  null
  
)

export default component.exports